import React, { useState } from 'react';
import SearchConstraints from './searchConstraints';
import SearchInfo from './searchInfo';
import SearchPathSelector from './SearchPathSelector';
import { ESearchPathFilters, searchPathFilterOptions } from '../constants';

const Search = (props) => {
  const [selectedPathFilter, setSelectedPathFilter] = useState<ESearchPathFilters>(
    searchPathFilterOptions[0].value as ESearchPathFilters,
  );
  const handlePathFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedPathFilter(e.target.value as ESearchPathFilters);
  };
  return (
    <div
      id="index-search-main-container"
      className="px-3 content-width bg-white w-full h-full gap-10"
    >
      <div id="index-search-info" className="h-[13%]">
        <SearchInfo
          selectedPathFilter={selectedPathFilter}
          setSelectedPathFilter={handlePathFilterChange}
        />
      </div>
      <div id="index-search-details" className="flex-row w-full flex mt-[3%] h-[69%]">
        <div id="index-search-details-search-path-selector" className="w-4/12">
          <div
            id="index-search-details-search-path-selector-wrapper"
            className="w-[93.5%] rounded-sm border border-gray-500 h-full"
          >
            <div
              id="index-search-details-search-path-selector-main"
              className="p-1 w-full flex-row h-full"
            >
              <SearchPathSelector selectedPathFilter={selectedPathFilter} />
            </div>
          </div>
        </div>
        <div
          id="index-search-details-search-constraints"
          className="w-8/12 flex flex-col mt-3 "
        >
          <SearchConstraints />
        </div>
      </div>
    </div>
  );
};

export default Search;
